import VDialogUpdateRecord from './index.vue';

export default {
  install: (Vue) => Vue.component('VDialogUpdateRecord', VDialogUpdateRecord),
};
